exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-users-os-warning-icon{padding-right:.5rem}.admin-users-os-choose-btn{height:34px;border-top-left-radius:0px;border-bottom-left-radius:0px}.admin-users-os-choose-btn-has-os{display:inline}.admin-users-os-choose-btn-has-no-os{display:inline;margin-right:5rem;opacity:.6}.admin-users-os-in-use{color:#FF6600}.admin-users-os-not-in-use{color:#45BF55}.admin-users-os-id{opacity:.3;padding-left:.5rem}\n", ""]);

// exports
